// Адрес раздела «Квоты»: бассейн, вкладка, год, вид и район квоты. Ссылка, которой
// делятся, открывает тот же разрез. Ключи свои (`qb`, `qv`, `qy`, `qs`, `qz`):
// общие `lat`/`lng` держит вид карты, и смешивать их нельзя.
//
// Рубежи — общими ключами `eez`/`fd` (как у «Правил», «Буёв», «Скаута»), оба
// выключены по умолчанию (решение владельца 30.10.2026): районы квоты и так
// закрашены тоннами, а контуры всех районов поверх них — лишние линии.
//
// Код вида и района бывает отрицательным: так сервер называет то, чему приказ
// кода не дал (международные распределения, `name_code` в src/cabinet/quotas.py).

export type QuotasView = 'alloc' | 'shares' | 'tac'
export const QUOTAS_VIEWS: QuotasView[] = ['alloc', 'shares', 'tac']
export const DEFAULT_BASIN = 'far_east'

export interface QuotasUrlState {
  basin: string
  view: QuotasView
  year: number | null
  species: number | null
  zone: number | null
  eez: boolean
  fd: boolean
}

export const QUOTAS_URL_KEYS = ['qb', 'qv', 'qy', 'qs', 'qz', 'eez', 'fd'] as const

function int(v: string | null): number | null {
  if (v == null || !/^-?\d+$/.test(v)) return null
  return Number(v)
}

export function parseQuotasUrl(p: URLSearchParams): QuotasUrlState {
  const v = p.get('qv') as QuotasView | null
  const b = p.get('qb')
  return {
    basin: b && /^[a-z_]{1,32}$/.test(b) ? b : DEFAULT_BASIN,
    view: v && QUOTAS_VIEWS.includes(v) ? v : 'alloc',
    year: int(p.get('qy')), species: int(p.get('qs')), zone: int(p.get('qz')),
    eez: p.get('eez') === '1',
    fd: p.get('fd') === '1',
  }
}

export function writeQuotasUrl(s: QuotasUrlState): URLSearchParams {
  const out = new URLSearchParams()
  if (s.basin !== DEFAULT_BASIN) out.set('qb', s.basin)
  if (s.view !== 'alloc') out.set('qv', s.view)
  if (s.year != null) out.set('qy', String(s.year))
  if (s.species != null) out.set('qs', String(s.species))
  if (s.zone != null) out.set('qz', String(s.zone))
  if (s.eez) out.set('eez', '1')
  if (s.fd) out.set('fd', '1')
  return out
}
